module.exports = {"130871104":"冯营子镇","130871106":"上板城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130871.json
// module id = 298
// module chunks = 0